import React, { useEffect, useState } from 'react';
import { Box } from '@material-ui/core';
import PropTypes from 'prop-types';
import { Link, useLocation } from 'react-router-dom';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import { useDispatch } from 'react-redux';

import ProductImageMobile from './ProductImageMobile';
import ProductInformation from './ProductInformation';
import { PRODUCT_DETAIL_MOBILE_ROUTE } from '../../../../../constants/Routes';
import ProductTicket from '../productTicket/ProductTicket';
import ProductMessage from '../ProductMessage';
import { useProductContainerMobileStyles } from './styles';

import { getImage } from '../../../../../redux/actions/ImageActions';
import { setSelectedProduct } from '../../../../../redux/actions/ProductActions';

const ProductContainerMobile = ({ ...props }) => {
  const { product, tickets } = props;
  const [productTickets, setProductTickets] = useState([]);
  const [color, setColor] = useState('#d9d9d9');
  const dispatch = useDispatch();
  const location = useLocation();
  const classes = useProductContainerMobileStyles({
    color,
  });

  const setProductSelected = () => dispatch(setSelectedProduct(product));

  useEffect(() => {
    dispatch(getImage(product.sku));
  }, []);

  useEffect(() => {
    if (product.nc) setColor('#007e2e');
    if (productTickets.length) setColor('#5B73BA');
    else if (!product.nc && !productTickets.length) setColor('#d9d9d9');
  }, [product, productTickets]);

  useEffect(() => {
    setProductTickets(
      tickets.filter(
        (ticket) =>
          ticket.orderId === product.orderId.toString() &&
          ticket.sku === product.sku,
      ),
    );
  }, [tickets]);

  return (
    <React.Fragment>
      <Box className={classes.container}>
        <Link
          to={{
            pathname: PRODUCT_DETAIL_MOBILE_ROUTE,
            state: {
              product,
              prevRoute: location.pathname,
            },
          }}
          className={classes.link}
          data-cy="linkDetailMobile"
        >
          <Box display="flex" alignItems="center" onClick={setProductSelected}>
            <ProductImageMobile
              isMkp={product.isMkp}
              src={product.thumbnailImage}
              purchaseState={product.purchaseState}
            />
            <ProductInformation
              name={product.name}
              orderId={product.orderId}
              purchaseDate={product.purchaseDate}
            />
            <KeyboardArrowRightIcon fontSize="large" />
          </Box>
        </Link>
      </Box>
      {product.nc && <ProductMessage type="nc" mobile />}
      {productTickets.length > 0 && (
        <ProductTicket mobile={true} tickets={productTickets} />
      )}
    </React.Fragment>
  );
};

ProductContainerMobile.propTypes = {
  product: PropTypes.object,
  tickets: PropTypes.array,
};

export default ProductContainerMobile;
